"use client";

import { motion, useReducedMotion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Consultation() {
  const prefersReducedMotion = useReducedMotion();
  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: prefersReducedMotion ? 0 : 0.1
      }
    }
  };
  const headlineVariants = prefersReducedMotion ? {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        duration: 0.2
      }
    }
  } : {
    hidden: {
      opacity: 0,
      y: 32,
      scale: 0.96
    },
    show: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };
  const itemVariants = prefersReducedMotion ? {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        duration: 0.2
      }
    }
  } : {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };
  const buttonPulse = prefersReducedMotion ? {} : {
    scale: [1, 1.015, 1],
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1],
      delay: 0.6
    }
  };
  return <section data-section-id="32583" id="localsearchdominancecta" className="bg-background text-foreground px-2 md:px-4 py-2">
      <div className="bg-primary md:rounded-[32px] px-8 md:px-16 py-40 md:py-56 overflow-hidden">
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.3
      }} className="mx-auto max-w-[960px] flex flex-col items-center text-center gap-8 md:gap-10">
          <motion.p variants={itemVariants} className="font-sans text-sm font-medium tracking-wide" style={{
          color: "hsl(0 0% 100% / 0.85)"
        }}>
            Ready to turn local searches into paying customers?
          </motion.p>

          <motion.h2 variants={headlineVariants} className="font-serif font-normal lowercase text-primary-foreground" style={{
          fontSize: "clamp(36px, 4.5vw, 58px)",
          lineHeight: "0.88",
          letterSpacing: "-0.03em"
        }}>
            grow your search.
          </motion.h2>

          <motion.p variants={itemVariants} className="font-sans font-normal max-w-2xl" style={{
          color: "hsl(0 0% 100% / 0.9)",
          fontSize: "clamp(20px, 1.8vw, 25px)",
          lineHeight: "1.55",
          letterSpacing: "-0.005em"
        }}>
            Book a free consultation to discuss your SEO strategy.
          </motion.p>

          <motion.div variants={itemVariants} animate={buttonPulse} className="w-full flex justify-center">
            <motion.div whileHover={prefersReducedMotion ? {} : {
            scale: 1.02,
            y: -2
          }} transition={{
            duration: 0.25,
            ease: [0.22, 1, 0.36, 1]
          }} className="w-full max-w-[320px] md:w-auto md:max-w-none">
              <Button asChild className="w-full md:w-auto h-auto rounded-lg bg-background text-primary hover:bg-background/95 font-sans font-semibold text-[19px] px-11 py-5 border-0">
                <Link to="/ContactPage">Book a free consultation</Link>
              </Button>
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}